import React from 'react';
import { Cpu, Zap, Cloud, Code2, Users2, Leaf } from 'lucide-react';

const ReductionMeasuresSection = () => {
  const measures = [
    {
      icon: <Cpu className="h-6 w-6 text-green-400" />,
      title: "Optimisation du Code",
      description: "Nous écrivons du code efficace et optimisé pour réduire la consommation de ressources.",
      color: "bg-blue-500/10"
    },
    {
      icon: <Zap className="h-6 w-6 text-green-400" />,
      title: "Énergie Verte",
      description: "Utilisation de serveurs alimentés par des énergies renouvelables.",
      color: "bg-yellow-500/10"
    },
    {
      icon: <Cloud className="h-6 w-6 text-green-400" />,
      title: "Cloud Optimisé",
      description: "Optimisation de l'infrastructure cloud pour minimiser la consommation d'énergie.",
      color: "bg-purple-500/10"
    },
    {
      icon: <Code2 className="h-6 w-6 text-green-400" />,
      title: "Développement Durable",
      description: "Processus de développement optimisé pour réduire les déchets numériques.",
      color: "bg-green-500/10"
    },
    {
      icon: <Users2 className="h-6 w-6 text-green-400" />,
      title: "Télétravail",
      description: "Pratique du télétravail pour réduire les émissions liées aux déplacements.",
      color: "bg-orange-500/10"
    },
    {
      icon: <Leaf className="h-6 w-6 text-green-400" />,
      title: "Pratiques Écologiques",
      description: "Mise en place de pratiques écologiques dans nos bureaux et processus.",
      color: "bg-teal-500/10"
    }
  ];

  return (
    <section className="pb-24 pt-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-6">
            Des Mesures Concrètes pour Réduire Notre Impact
          </h2>
          <p className="text-xl text-slate-600">
            Nous mettons en œuvre des solutions pour minimiser notre empreinte environnementale 
            à chaque étape de nos projets.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {measures.map((measure, index) => (
            <div key={index} className="group bg-slate-50 p-8 rounded-xl border border-slate-200 hover:border-green-200 transition-colors">
              <div className="flex flex-col h-full">
                <div className={`${measure.color} p-4 rounded-lg w-fit mb-6`}>
                  {measure.icon}
                </div>
                <h3 className="text-xl font-semibold text-slate-900 mb-3">
                  {measure.title}
                </h3>
                <p className="text-slate-600 mb-4 flex-grow">
                  {measure.description}
                </p>  
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReductionMeasuresSection; 